<template>
  <div class="language-box">
    <Popover
      :width="220"
      placement="bottom"
      trigger="click"
    >
      <template #reference>
        <div class="trigger-wrapper">
          <Icon
            name="icon-language-glabal-l"
            style="font-size: 16px;"
          />
          {{ language.current?.toUpperCase() }}
          <Icon name="arrow-down-l-2" />
        </div>
      </template>
      <div class="dropdown-content-item-list">
        <div
          class="dropdown-item"
          v-for="(lang, index) in language.list"
          :key="index"
          :class="{ selected: lang.language === language.current }"
          @click="language.update(lang.language)"
        >
          {{ lang.sourceLan }} / {{ lang.language?.toUpperCase() }}
          <Icon
            v-if="lang.language === language.current"
            class="active-icon"
            name="right-l"
          />
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup>
import Icon from '@/components/Icon/Icon.vue'
import Popover from '@/components/Popover/index.vue'
import { useLanguageStore } from '@/pinia/language'

const language = useLanguageStore()

</script>

<style lang="less" scoped>
.language-box {
  position: absolute;
  top: 0;
}
.trigger-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 76px;
  height: 40px;
  cursor: pointer;
  color: #052785;
  font-family: mon-500;
  font-size: 12px;
}

.dropdown-content-item-list {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  color: #6e717a;
  font-size: 12px;
  height: 220px;

  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: mon-500;
    padding: 8px;
    margin-top: 4px;
    margin-bottom: 4px;
    cursor: pointer;
    position: relative;
    &:hover {
      border-radius: 4px;
      background: #f5f5f5;
      color: #232323;
    }
    &.selected {
      border-radius: 4px;
      background: #f5f5f5;
      color: #232323;
    }
  }
}
</style>
